import React, { useEffect, useState } from "react";

function CountdownTimer() {
    const targetDate = new Date("2026-08-21T08:00:00");

    const calculateTimeLeft = () => {
        const now = new Date();
        const difference = targetDate - now;

        if (difference <= 0) return null;

        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / (1000 * 60)) % 60),
            seconds: Math.floor((difference / 1000) % 60)
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    if (!timeLeft) {
        return (
            <div style={styles.finished}>
                🎉 It's MUN Time!
            </div>
        );
    }

    return (
        <div style={styles.wrapper}>
            <div style={styles.container}>
                <TimeBlock value={timeLeft.days} label="Days" />
                <TimeBlock value={timeLeft.hours} label="Hours" />
                <TimeBlock value={timeLeft.minutes} label="Minutes" />
                <TimeBlock value={timeLeft.seconds} label="Seconds" />
            </div>
        </div>
    );
}

function TimeBlock({ value, label }) {
    return (
        <div style={styles.timeBlock}>
            <div style={styles.timeValue}>{value}</div>
            <div style={styles.timeLabel}>{label}</div>
        </div>
    );
}


const styles = {
    wrapper: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        padding: "20px 10px",
        boxSizing: "border-box"
    },
    container: {
        display: "flex",
        width: "100%",
        maxWidth: "900px",
        justifyContent: "space-between",
        gap: "15px",
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
        padding: "20px"
    },
    timeBlock: {
        flex: 1,
        backgroundColor: "rgb(13 15 18)",
        color: "#fff",
        borderRadius: "8px",
        padding: "15px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    timeValue: {
        fontSize: "2rem",
        fontWeight: "600",
        marginBottom: "5px"
    },
    timeLabel: {
        fontSize: "1rem",
        opacity: 0.9,
        fontWeight: "400"
    },
    finished: {
        fontSize: "1.8rem",
        fontWeight: "bold",
        color: "#28a745",
        textAlign: "center",
        padding: "20px"
    }
};



export default CountdownTimer;
